@if (!isDesktop || !annotationMode) {
  <div class="create-comment-mobile-bg" (click)="onClose.emit()"></div>
}

@if (!isDesktop) {
  <app-avatar
    class="mobile-comment-avatar"
    [user]="state.user || state.guest"
    [style.left]="commentPlacePosition?.x + 'px'"
    [style.top]="commentPlacePosition?.y + 'px'"
  ></app-avatar>
}

<div
  #overlay
  class="create-comment-overlay"
  [class.private]="commentMessage.private"
  [@createCommentOverlay]
  [style.left]="isDesktop ? position?.x + 'px' : undefined"
  [style.top]="isDesktop ? position?.y + 'px' : undefined"
>
  <app-avatar
    [user]="state.user || state.guest"
    [class.dragging]="dragging()"
    (mousedown)="mouseDown()"
    (mousemove)="mouseMove($event)"
    (mouseup)="mouseUp()"
    [class.align-left]="commentPlaceAlignment === 'left'"
  ></app-avatar>
  <div class="textarea-container">
    @if (isDesktop) {
      <div
        class="drag-handle"
        [class.dragging]="dragging()"
        (mousedown)="mouseDown()"
        (mousemove)="mouseMove($event)"
        (mouseup)="mouseUp()"
      ></div>
    }
    <div
      class="textarea"
      name="new-thread-from-overlay"
      contenteditable
      [(wysiwyg)]="commentMessage.text"
      [allowHtml]="true"
      #commentField
    ></div>
    @if (!commentMessage.text.length) {
      <div class="placeholder">{{ 'add-a-comment' | translate }}...</div>
    }

    <div class="message-actions" [@messageActions]>
      <div class="spacer"></div>

      @if (accessLevel === 'edit' && isTeamMember) {
        <button
          appButton
          name="toggle-private"
          location="create-comment-overlay"
          appTooltip="Team only"
          [iconButton]="true"
          [color]="commentMessage.private ? 'simple-orange' : 'simple'"
          shape="round"
          height="-1"
          (click)="togglePrivate()"
        >
          @if (commentMessage.private) {
            <app-svg src="/assets/icons/lock.svg"></app-svg>
          } @else {
            <app-svg src="/assets/icons/lock-off.svg"></app-svg>
          }
        </button>
      }

      <app-context-menu [options]="{ width: '360px', noSpacing: true }" class="emoji-toggle" #emojiMenu>
        <button
          appButton
          name="add-emoji"
          location="create-comment-overlay"
          [iconButton]="true"
          color="simple"
          height="-1"
          appTooltip="Add emojis"
          contextButton
          shape="round"
        >
          <app-svg src="/assets/icons/24/smiley-outline.svg" size="0"></app-svg>
        </button>
        <div contextContent>
          @defer (when emojiMenu.isOpen) {
            <app-emoji-selector (onSelect)="addEmoji($event)"></app-emoji-selector>
          } @error {}
        </div>
      </app-context-menu>

      <button
        appButton
        name="send"
        location="create-comment-overlay"
        color="primary"
        height="1"
        spacing="3"
        shape="round"
        (click)="postNewThread()"
        class="send-button"
      >
        Send
      </button>
    </div>
  </div>
</div>
